const constants = {}

constants.advisors = [
  'Angel Maita',
  'Juan Rios',
  'Manuela Motta'
]

constants.owners = [
  'Alberto Rojas',
  'Raiser Rodriguez',
  'Javier Ruiz'
]

constants.enableInTheWeb = [
  'Si',
  'No'
]

constants.propertiesTypes = [
  { label: 'Apartamento', value: '1' },
  { label: 'Bodega', value: '2' },
  { label: 'Casa', value: '3' },
  { label: 'Finca', value: '4' },
  { label: 'Local', value: '5' },
  { label: 'Lote', value: '6' },
  { label: 'Oficina', value: '7' },
  { label: 'Lote Industrial', value: '8' },
  { label: 'Casa Comercial', value: '9' },
  { label: 'Amoblados', value: '10' },
  { label: 'Casa Campestre', value: '11' },
  { label: 'Consultorio', value: '12' },
  { label: 'Edificio', value: '13' }
]

constants.purpose = [
  'Arriendo',
  'Venta',
  'Venta y Arriendo'
]

constants.purposeForFilters = [
  { label: 'Arriendo', value: 'arriendo' },
  { label: 'Venta', value: 'venta' }
]

constants.state = [
  'En venta',
  'En arriendo',
  'En venta y arriendo'
]

constants.stratum = [
  'No Aplica',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  'Estrato Comercial'
]

constants.zone = [
  'Córdoba',
  'Medellín, Área metropolitana',
  'Oriente Antioqueño',
  'Suroeste Antioqueño',
  'Cartagena'
]

constants.sectors = [
  'CARTAGENA',
  'POBLADO',
  'SABANETA',
  'CALDAS',
  'LA ESTRELLA'
]

constants.neighborhoods = [
  'CARTAGENA',
  'LA ASOMADERA (EN FRENTE DE ASIA)',
  'LOMA DEL INDIO',
  'SAN DIEGO',
  'CASTROPOL'
]

constants.pentHouse = [
  'Aplica',
  'No Aplica'
]

constants.duplex = [
  'No Aplica',
  '1 Nivel',
  '2 Nivel',
  '3 o mas niveles'
]

constants.bathrooms = [
  'No Aplica',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10'
]

constants.bedrooms = [
  'No Aplica',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9'
]

constants.serviceBathroom = [
  'No Aplica',
  'Si',
  'No'
]

constants.serviceBedroom = [
  'No Aplica',
  'Si',
  'No'
]

constants.diningRoom = [
  'No Aplica',
  'Salón Comedor',
  'Comedor Independiente'
]

constants.livingRoom = [
  'No Aplica',
  'Si',
  'No'
]

constants.library = [
  'No Aplica',
  'Si',
  'No'
]

constants.lounge = [
  'No Aplica',
  'Si',
  'No'
]

constants.balcony = [
  'No Aplica',
  'Si',
  'No'
]

constants.terrace = [
  'No Aplica',
  'Si',
  'No'
]

constants.kitchen = [
  'No Aplica',
  'Integral',
  'Abierta',
  'Cocineta',
  'Sencilla',
  'Otra'
]

constants.clothingArea = [
  'No Aplica',
  'Si',
  'No'
]

constants.garage = [
  'No Aplica',
  'No',
  '1',
  '2L',
  '2P',
  '3',
  '4',
  '5 ó más'
]

constants.utilityRoom = [
  'No Aplica',
  'No',
  '1',
  '2',
  '3 ó más'
]

constants.waterHeater = [
  'Gás',
  'Eléctrico',
  'Natural'
]

constants.gasType = [
  'Red de gas',
  'Pipeta'
]

constants.outstandingProperty = [
  'No',
  'Si'
]

constants.propertyFrequency = [
  'Trimestral',
  'Semestral',
  'Anual',
  'Otro'
]

constants.otherInternalCharacteristics = [
  'Agua propia',
  'Chimenea',
  'Jardín',
  'Doble altura',
  'Puerta camión',
  'Casa mayordomo',
  'Jacuzzi privado',
  'Aire acondicionado',
  'Otro'
]

constants.closedUnit = [
  'Si',
  'No',
  'No Aplica'
]

constants.gender = [
  'Masculino',
  'Femenino'
]

constants.portersLodge = [
  'No Aplica',
  '24 Horas',
  'Diurna',
  'Nocturna',
  'No',
  'Fin de semana',
  'Otra'
]

constants.elevator = [
  'No Aplica',
  'Si',
  'No'
]

constants.commonAreas = [
  'Aire acondicionado centralizado',
  'Auditorio',
  'Cancha Polideportiva',
  'Cancha Squash',
  'Cancha Tennis',
  'Guardería',
  'Gimnasio',
  'Jacuzzi',
  'Juegos Infantiles',
  'Parqueadero Visitante',
  'Piscina',
  'Salón Social',
  'Sauna',
  'Sendero Ecológico',
  'Sky Club',
  'Solárium',
  'Turco',
  'Vías Pavimentadas',
  'Zona BBQ',
  'Zonas Verdes'
]

constants.profile = [
  'Propietario',
  'Colega'
]

constants.unpublishStatus = [
  { label: 'Vendido', icon: 'fas fa-money-bill-wave' },
  { label: 'Arrendado', icon: 'fas fa-key' },
  { label: 'Retirado', icon: 'fas fa-times-circle' }
]

export default constants
